import React from 'react';
import { usePlanningActualState } from '../Context/index';

function OptionsTable({ years, categoryItem }) {
  const { checkVisible, getFieldValue, getTotalOfField, getVSData, getVSCategoryTotal } = usePlanningActualState();
  const options = [
    {
      keyName: 'plannedOption',
      name: 'Planned Options',
      type: 'input',
      display: true,
      Total: 0,
    },
    {
      keyName: 'actualOption',
      name: 'Actual Options',
      type: 'input',
      display: true,
      Total: 0,
    },
  ];

  return (
    <>
      {(years ?? []).map((currentYear, yearIndex) => {
        return (
          <table key={yearIndex} className="table custom-table layout-fixed  font-13 mr-3">
            <thead>
              <tr>
                {options.map((salesItem, i) => {
                  const isVisible = checkVisible(salesItem.keyName);
                  return (
                    isVisible && (
                      <th key={i} className="w-200px">
                        <span>
                          {currentYear}&nbsp;
                          {salesItem.name}
                        </span>
                      </th>
                    )
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {categoryItem?.subcategory &&
                categoryItem.subcategory.map((cat2Ele, iCat) => {
                  return (
                    <tr key={iCat}>
                      {options.map((salesItem, i) => {
                        const isVisible = checkVisible(salesItem.keyName);
                        return (
                          isVisible && (
                            <td key={i}>
                              {getFieldValue(salesItem.keyName, yearIndex, currentYear, cat2Ele.subcategoryId._id, categoryItem?.categoryId?._id)}
                            </td>
                          )
                        );
                      })}
                    </tr>
                  );
                })}
            </tbody>
            <tfoot>
              <tr>
                {options.map((item, i) => {
                  const isVisible = checkVisible(item.keyName);
                  return (
                    isVisible && (
                      <td key={i}>
                        <b>{getTotalOfField(item.keyName, yearIndex, currentYear, categoryItem?.categoryId?._id)}</b>
                      </td>
                    )
                  );
                })}
              </tr>
            </tfoot>
          </table>
        );
      })}
      <table className="table custom-table layout-fixed font-13 mr-3">
        <thead>
          <tr>
            {(years ?? []).map((childYear, i) => {
              return (
                i > 0 && (
                  <th key={i} className="w-200px">
                    <span>
                      {years[0]} vs {childYear} (%)
                    </span>
                  </th>
                )
              );
            })}
          </tr>
        </thead>
        <tbody>
          {categoryItem?.subcategory &&
            categoryItem.subcategory.map((cat2Elevs, iCatvs) => {
              return (
                <tr key={iCatvs}>
                  {(years ?? []).map((eleYear, iYear) => {
                    return (
                      iYear > 0 && (
                        <td key={iYear} className="w-200px">
                          <span>{getVSData('vsOptionItem', eleYear, cat2Elevs.subcategoryId._id, categoryItem?.categoryId?._id)}</span>
                        </td>
                      )
                    );
                  })}
                </tr>
              );
            })}
        </tbody>
        <tfoot>
          <tr>
            {(years ?? []).map((eleYear, iYear) => {
              return (
                iYear > 0 && (
                  <td key={iYear} className="w-200px">
                    <b>{getVSCategoryTotal('plannedOption', 'actualOption', eleYear, categoryItem?.categoryId?._id)}</b>
                  </td>
                )
              );
            })}
          </tr>
        </tfoot>
      </table>
    </>
  );
}
export default OptionsTable;
